import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TokenState {
    tokenStateObservable: BehaviorSubject<string>;
    tokenStateEventEmitter = new EventEmitter();

    constructor() {
        this.tokenStateObservable = new BehaviorSubject('initial');
    }

    public getTokenStateObservable() {
        return this.tokenStateObservable;
    }

    public setTokenStateObservable(state) {
        this.tokenStateObservable.next(state);
    }
}
